const kn = {
    "gui.menuBar.file": "ಫೈಲ್",
    "gui.menuBar.edit": "ಸಂಪಾದಿಸು",
    "gui.menuBar.new": "ಹೊಸದು",
    "gui.menuBar.saveNow": "ಈಗ ಉಳಿಸು",
    "gui.menuBar.saveAsCopy": "ನಕಲು ಆಗಿ ಉಳಿಸು",
    "gui.menuBar.remix": "ರೀಮಿಕ್ಸ್",
    "gui.menuBar.languageSelector": "ಭಾಷಾ ಆಯ್ಕೆಕಾರ",
    "gui.menuBar.tutorialsLibrary": "ಟ್ಯುಟೋರಿಯಲ್‌ಗಳು",
    "gui.menuBar.community": "ಸಮುದಾಯ",
    "gui.menuBar.wiki": "ಏಜೆಂಟ್ ಅನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "gui.menuBar.restoreSprite": "ಸ್ಪ್ರೈಟ್ ಮರುಸ್ಥಾಪಿಸು",
    "gui.menuBar.restoreSound": "ಧ್ವನಿ ಮರುಸ್ಥಾಪಿಸು",
    "gui.menuBar.restoreCostume": "ವೇಷಭೂಷಣ ಮರುಸ್ಥಾಪಿಸು",
    "gui.menuBar.restore": "ಮರುಸ್ಥಾಪಿಸು",
    "gui.menuBar.turboModeOff": "ಟರ್ಬೊ ಮೋಡ್ ಆಫ್",
    "gui.menuBar.turboModeOn": "ಟರ್ಬೊ ಮೋಡ್ ಆನ್",
    "gui.menuBar.noDeviceSelected": "ಸಾಧನ ಆಯ್ಕೆ ಮಾಡಿ",
    "gui.menuBar.noConnection": "ಸಂಪರ್ಕವಿಲ್ಲ",
    "gui.menuBar.downloadToComputer": "ನಿಮ್ಮ ಕಂಪ್ಯೂಟರ್‌ಗೆ ಉಳಿಸು",
    "gui.menuBar.checkUpdate": "ನವೀಕರಣಕ್ಕಾಗಿ ಪರಿಶೀಲಿಸು",
    "gui.menuBar.installDriver": "ಡ್ರೈವರ್ ಸ್ಥಾಪಿಸು",
    "gui.menuBar.clearCacheAndRestart":
        "ಕ್ಯಾಶ್ ತೆರವುಗೊಳಿಸಿ ಮತ್ತು ಮರುಪ್ರಾರಂಭಿಸು",
    "gui.alerts.createsuccess": "ಹೊಸ ಯೋಜನೆ ರಚಿಸಲಾಗಿದೆ.",
    "gui.alerts.createcopysuccess": "ಯೋಜನೆಯನ್ನು ನಕಲು ಆಗಿ ಉಳಿಸಲಾಗಿದೆ.",
    "gui.alerts.createremixsuccess": "ಯೋಜನೆಯನ್ನು ರೀಮಿಕ್ಸ್ ಆಗಿ ಉಳಿಸಲಾಗಿದೆ.",
    "gui.alerts.creating": "ಹೊಸದನ್ನು ರಚಿಸಲಾಗುತ್ತಿದೆ...",
    "gui.alerts.creatingCopy": "ಯೋಜನೆಯ ನಕಲು ರಚಿಸಲಾಗುತ್ತಿದೆ...",
    "gui.alerts.creatingRemix": "ಯೋಜನೆಯ ರೀಮಿಕ್ಸ್ ರಚಿಸಲಾಗುತ್ತಿದೆ...",
    "gui.alerts.downloading": "ಡೌನ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    "gui.alerts.loading": "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    "gui.alerts.saving": "ಉಳಿಸಲಾಗುತ್ತಿದೆ...",
    "gui.alerts.savesuccess": "ಯೋಜನೆ ಉಳಿಸಲಾಗಿದೆ.",
    "gui.alerts.savingError": "ಯೋಜನೆಯನ್ನು ಉಳಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.",
    "gui.gui.addExtension": "ವಿಸ್ತರಣೆ ಸೇರಿಸು",
    "gui.gui.code": "ಕೋಡ್",
    "gui.gui.backdrops": "ಹಿನ್ನೆಲೆಗಳು",
    "gui.gui.costumes": "ವೇಷಭೂಷಣಗಳು",
    "gui.gui.sounds": "ಧ್ವನಿಗಳು",
    "gui.gui.codeTab": "ಕೋಡ್",
    "gui.gui.costumesTab": "ವೇಷಭೂಷಣಗಳು",
    "gui.gui.backdropsTab": "ಹಿನ್ನೆಲೆಗಳು",
    "gui.gui.soundsTab": "ಧ್ವನಿಗಳು",
    "gui.library.filterPlaceholder": "ಹುಡುಕು",
    "gui.library.allTag": "ಎಲ್ಲಾ",
    "gui.loader.headline": "ಯೋಜನೆ ಲೋಡ್ ಆಗುತ್ತಿದೆ",
    "gui.loader.creating": "ಯೋಜನೆ ರಚಿಸಲಾಗುತ್ತಿದೆ",
    "gui.spriteLibrary.chooseASprite": "ಸ್ಪ್ರೈಟ್ ಆಯ್ಕೆಮಾಡಿ",
    "gui.spriteLibrary.paintASprite": "ಚಿತ್ರಿಸು",
    "gui.spriteLibrary.uploadASprite": "ಸ್ಪ್ರೈಟ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    "gui.spriteLibrary.surprise": "ಆಶ್ಚರ್ಯ",
    "gui.soundLibrary.chooseASound": "ಧ್ವನಿ ಆಯ್ಕೆಮಾಡಿ",
    "gui.soundLibrary.record": "ರೆಕಾರ್ಡ್",
    "gui.soundLibrary.uploadASound": "ಧ್ವನಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    "gui.gui.defaultProjectTitle": "TIFStudio Project",
    "gui.alerts.lostPeripheralConnection":
        "TIFStudio lost connection to {extensionName}.",
    "gui.connection.unavailable.installscratchlink":
        "Make sure you have TIFStudio Agent installed and running in your system tray",
    "gui.menuBar.turnOffCamera": "ಕ್ಯಾಮೆರಾ ಆಫ್ ಮಾಡಿ",
    "gui.menu-bar.realtimeMode": "ಸ್ಕ್ರ್ಯಾಚ್",
    "gui.menu-bar.programMode": "ಪ್ರೋಗ್ರಾಮ",
    "gui.extensionLibrary.comingSoon": "ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ",
    "gui.extensionLibrary.requires": "ಅಗತ್ಯವಿದೆ",
    "gui.extensionLibrary.collaboration": "ಸಹಯೋಗದೊಂದಿಗೆ",
    // Extension Library Metadata
    "gui.extensionLibrary.manufactor": "ತಯಾರಕ",
    "gui.extensionLibrary.version": "ಆವೃತ್ತಿ",
    "gui.extensionLibrary.author": "ಲೇಖಕ",
    "gui.extensionLibrary.programMode": "ಪ್ರೋಗ್ರಾಂ ಮೋಡ್",
    "gui.extensionLibrary.programLanguage": "ಪ್ರೋಗ್ರಾಂ ಭಾಷೆ",
    "gui.extensionLibrary.deviceLearnMore": "ಇನ್ನು ತಿಳಿಯಿರಿ",
    "gui.extensionLibrary.extensionHelp": "ಸಹಾಯ",
    "gui.extensionLibrary.Processing": "ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ...",
    "gui.extensionLibrary.loaded": "ಲೋಡ್ ಆಗಿದೆ",
    "gui.extensionLibrary.notLoaded": "ಲೋಡ್ ಆಗಿಲ್ಲ",
    "gui.extensionLibrary.chooseAnExtension": "ವಿಸ್ತರಣೆ ಆಯ್ಕೆಮಾಡಿ",
    "gui.hardwareHeader.upload": "ಅಪ್ಲೋಡ್",
    "gui.costumeLibrary.chooseACostume": "ವೇಷಭೂಷಣ ಆಯ್ಕೆಮಾಡಿ",
    "gui.costumeLibrary.paintACostume": "ಚಿತ್ರಿಸು",
    "gui.costumeLibrary.uploadACostume": "ವೇಷಭೂಷಣ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    "gui.backdropLibrary.chooseABackdrop": "ಹಿನ್ನೆಲೆ ಆಯ್ಕೆಮಾಡಿ",
    "gui.backdropLibrary.paintABackdrop": "ಚಿತ್ರಿಸು",
    "gui.backdropLibrary.uploadABackdrop": "ಹಿನ್ನೆಲೆ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    "gui.stageSelector.stage": "ವೇದಿಕೆ",
    "gui.stageSelector.backdrops": "ಹಿನ್ನೆಲೆಗಳು",
    "gui.spriteSelectorItem.contextMenuDuplicate": "ನಕಲು ಮಾಡು",
    "gui.spriteSelectorItem.contextMenuExport": "ರಫ್ತು ಮಾಡು",
    "gui.spriteSelectorItem.contextMenuDelete": "ಅಳಿಸು",
    "gui.spriteInfo.sprite": "ಸ್ಪ್ರೈಟ್",
    "gui.spriteInfo.size": "ಗಾತ್ರ",
    "gui.spriteInfo.show": "ತೋರಿಸು",
    "gui.spriteInfo.direction": "ದಿಕ್ಕು",
    "gui.deviceLibrary.chooseADevice": "ಸಾಧನ ಆಯ್ಕೆಮಾಡಿ",
    "gui.playButton.play": "ಪ್ಲೇ",
    "gui.playButton.stop": "ನಿಲ್ಲಿಸು",
    "gui.gui.variablePromptDefaultValue": "ನನ್ನ ವೇರಿಯಬಲ್",
    "gui.gui.listVariable": "ಪಟ್ಟಿ ರಚಿಸು",
    "gui.gui.makeAVariable": "ವೇರಿಯಬಲ್ ರಚಿಸು",
    "gui.gui.newVariable": "ಹೊಸ ವೇರಿಯಬಲ್",
    "gui.soundEditor.sound": "ಧ್ವನಿ",
    "gui.soundEditor.play": "ಪ್ಲೇ",
    "gui.soundEditor.stop": "ನಿಲ್ಲಿಸು",
    "gui.soundEditor.copy": "ನಕಲು",
    "gui.soundEditor.paste": "ಅಂಟಿಸು",
    "gui.soundEditor.delete": "ಅಳಿಸು",
    "gui.soundEditor.save": "ಉಳಿಸು",
    "gui.soundEditor.undo": "ರದ್ದುಮಾಡು",
    "gui.soundEditor.redo": "ಮತ್ತೆ ಮಾಡು",
    "paint.paintEditor.hue": "ಬಣ್ಣ",
    "paint.paintEditor.saturation": "ಸ್ಯಾಚುರೇಶನ್",
    "paint.paintEditor.brightness": "ಪ್ರಕಾಶ",
    "paint.paintEditor.fill": "ತುಂಬಿಸು",
    "paint.paintEditor.costume": "ವೇಷಭೂಷಣ",
    "paint.paintEditor.group": "ಗುಂಪು",
    "paint.paintEditor.ungroup": "ಗುಂಪು ರದ್ದುಮಾಡು",
    "paint.paintEditor.undo": "ರದ್ದುಮಾಡು",
    "paint.paintEditor.redo": "ಮತ್ತೆ ಮಾಡು",
    "paint.paintEditor.more": "ಹೆಚ್ಚು",
    "paint.modeTools.copy": "ನಕಲು",
    "paint.modeTools.paste": "ಅಂಟಿಸು",
    "paint.modeTools.delete": "ಅಳಿಸು",
    "paint.brushMode.brush": "ಬ್ರಷ್",
    "paint.eraserMode.eraser": "ಎರೇಸರ್",
    "paint.fillMode.fill": "ತುಂಬಿಸು",
    "paint.lineMode.line": "ರೇಖೆ",
    "paint.ovalMode.oval": "ವೃತ್ತ",
    "paint.rectMode.rect": "ಆಯತ",
    "paint.selectMode.select": "ಆಯ್ಕೆಮಾಡು",
    "paint.textMode.text": "ಪಠ್ಯ",
    "gui.connection.connect": "ಸಂಪರ್ಕಿಸು",
    "gui.connection.disconnect": "ಸಂಪರ್ಕ ಕಡಿತಗೊಳಿಸು",
    "gui.connection.connected": "ಸಂಪರ್ಕಗೊಂಡಿದೆ",
    "gui.connection.connecting": "ಸಂಪರ್ಕಿಸಲಾಗುತ್ತಿದೆ...",
    "gui.connection.error": "ದೋಷ",
    "blockly.deleteBlock": "ಬ್ಲಾಕ್ ಅಳಿಸು",
    "blockly.duplicateBlock": "ನಕಲು ಮಾಡು",
    "blockly.addComment": "ಟಿಪ್ಪಣಿ ಸೇರಿಸು",
    "blockly.removeComment": "ಟಿಪ್ಪಣಿ ತೆಗೆದುಹಾಕು",
    "blockly.help": "ಸಹಾಯ",
    "blockly.undo": "ರದ್ದುಮಾಡು",
    "blockly.redo": "ಮತ್ತೆ ಮಾಡು",

    // Device translations
    "gui.device.unselectDevice.name": "ಸಾಧನ ಆಯ್ಕೆ ರದ್ದುಮಾಡಿ",
    "gui.device.unselectDevice.description":
        "ಸಾಧನವನ್ನು ಆಯ್ಕೆ ರದ್ದುಮಾಡಿ, ಶುದ್ಧ ರಿಯಲ್‌ಟೈಮ್ ಪ್ರೋಗ್ರಾಮಿಂಗ್ ಮೋಡ್‌ಗೆ ಹಿಂತಿರುಗಿ.",
    "gui.device.connectingMessage": "ಸಂಪರ್ಕಿಸಲಾಗುತ್ತಿದೆ",
    "gui.device.arduinoUno.description":
        "ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಮತ್ತು ಕೋಡಿಂಗ್‌ನೊಂದಿಗೆ ಪ್ರಾರಂಭಿಸಲು ಉತ್ತಮ ಬೋರ್ಡ್.",
    "gui.device.arduinoNano.description":
        "Arduino Nano ನಿಮ್ಮ ಯೋಜನೆಗಳನ್ನು ನಿರ್ಮಿಸಲು ಕ್ಲಾಸಿಕ್ ಸಣ್ಣ ಬೋರ್ಡ್ ಆಗಿದೆ.",
    "gui.device.arduinoLeonardo.description":
        "ಮೌಸ್ ಅಥವಾ ಕೀಬೋರ್ಡ್ ಆಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸಬಲ್ಲ ಕ್ಲಾಸಿಕ್ Arduino ಬೋರ್ಡ್.",
    "gui.device.arduinoMega2560.description":
        "54 ಡಿಜಿಟಲ್ ಪಿನ್‌ಗಳು, 16 ಅನಲಾಗ್ ಇನ್‌ಪುಟ್‌ಗಳು ಮತ್ತು 4 ಸೀರಿಯಲ್ ಪೋರ್ಟ್‌ಗಳೊಂದಿಗೆ 8-ಬಿಟ್ ಬೋರ್ಡ್.",
    "gui.device.arduinoUnoR4Minima.description":
        "ಸುಧಾರಿತ ಕಾರ್ಯಕ್ಷಮತೆ ಮತ್ತು ವಿಸ್ತರಿತ ಮೆಮೊರಿಯನ್ನು ನೀಡುತ್ತದೆ, ಅಸ್ತಿತ್ವದಲ್ಲಿರುವ ಶೀಲ್ಡ್‌ಗಳು ಮತ್ತು ಪರಿಕರಗಳೊಂದಿಗೆ ಹೊಂದಾಣಿಕೆಯನ್ನು ನಿರ್ವಹಿಸುತ್ತದೆ.",
    "gui.device.arduinoUnoR4Wifi.description":
        "Wi-Fi ಮತ್ತು Bluetooth ಸಂಪರ್ಕವನ್ನು ಒದಗಿಸುತ್ತದೆ, ಜೊತೆಗೆ ದೃಶ್ಯೀಕರಣಕ್ಕಾಗಿ ಆನ್-ಬೋರ್ಡ್ 12x8 LED ಮ್ಯಾಟ್ರಿಕ್ಸ್.",
    "gui.device.esp32.description":
        "ಸಮೃದ್ಧ ಕಾರ್ಯಗಳೊಂದಿಗೆ Wi-Fi ಮತ್ತು Bluetooth ನಿಯಂತ್ರಣ ಬೋರ್ಡ್.",
    "gui.device.esp32S3.description":
        "ದಕ್ಷ, ಕಡಿಮೆ-ಶಕ್ತಿಯ IoT ಎಡ್ಜ್ ಮತ್ತು AI ವರ್ಕ್‌ಲೋಡ್‌ಗಳಿಗಾಗಿ ಸಮರ್ಪಿತ AI ವೇಗವರ್ಧಕ ಮತ್ತು ಸಮೃದ್ಧ ಪೆರಿಫೆರಲ್ ಸೆಟ್ ಅನ್ನು ಸಂಯೋಜಿಸುತ್ತದೆ.",
    "gui.device.esp8266NodeMCU.description":
        "ಕಡಿಮೆ-ವೆಚ್ಚದ Wi-Fi SOC ನಿಯಂತ್ರಣ ಬೋರ್ಡ್.",
    "gui.device.k210MaixDock.description":
        "K210 RISC-V ಚಿಪ್ ಆಧಾರಿತ ನಿಯಂತ್ರಣ ಬೋರ್ಡ್ ಕೇವಲ ಮೂಲಭೂತ ಕಾರ್ಯಗಳನ್ನು ಹೊಂದಿದೆ ಮತ್ತು ಎಲ್ಲಾ IO ಪಿನ್‌ಗಳನ್ನು ಹೊರತೆಗೆಯುತ್ತದೆ.",
    "gui.device.k210Maixduino.description": "ESP32 ಒಳಗೊಂಡ K210 RISC-V ಬೋರ್ಡ್.",
    "gui.device.raspberryPiPicoIconURL.description":
        "ನಿಮ್ಮ ಎಲೆಕ್ಟ್ರಾನಿಕ್ಸ್ ಕಲ್ಪನೆಗಳನ್ನು ಜೀವಂತಗೊಳಿಸುವ ಸ್ನೇಹಪರ, ಬಳಸಲು ಸುಲಭವಾದ ಮೈಕ್ರೋಕಂಟ್ರೋಲರ್ ಬೋರ್ಡ್.",
    "gui.device.raspberryPiPicoWIconURL.description":
        "ವೈರ್‌ಲೆಸ್ ಮತ್ತು IoT ಯೋಜನೆಗಳಿಗೆ ಪರಿಪೂರ್ಣವಾದ ಬಿಲ್ಟ್-ಇನ್ 2.4 GHz Wi-Fi ಮತ್ತು Bluetooth 5.2 ಹೊಂದಿರುವ Pico.",
    "gui.device.raspberryPiPico2IconURL.description":
        "ಸಂಕೀರ್ಣ ಅನ್ವಯಗಳಿಗಾಗಿ ಸಾಕಷ್ಟು RAM ಮತ್ತು ಫ್ಲ್ಯಾಶ್‌ನೊಂದಿಗೆ ಉನ್ನತ-ಕಾರ್ಯಕ್ಷಮತೆಯ ಡ್ಯುಯಲ್-ಕೋರ್ MCU.",
    "gui.device.raspberryPiPico2WIconURL.description":
        "ನಿರ್ಬಾಧ ವೈರ್‌ಲೆಸ್ IoT ಮತ್ತು ಸ್ಮಾರ್ಟ್-ಹೋಮ್ ಏಕೀಕರಣಕ್ಕಾಗಿ ಬಿಲ್ಟ್-ಇನ್ 2.4 GHz Wi-Fi ಮತ್ತು Bluetooth.",
    "gui.device.microbit.description":
        "ಡಿಜಿಟಲ್ ಕೌಶಲ್ಯ ಕಲಿಕೆಯನ್ನು ಪರಿವರ್ತಿಸುವ ಪಾಕೆಟ್-ಗಾತ್ರದ ಕಂಪ್ಯೂಟರ್.",
    "gui.device.microbitV2.description":
        "ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಿದ ಪ್ರೊಸೆಸರ್, ಬಿಲ್ಟ್-ಇನ್ ಸ್ಪೀಕರ್ ಮತ್ತು ಮೈಕ್ರೊಫೋನ್, ಸ್ಪರ್ಶ ಸಂವೇದನಾ ಲೋಗೋ.",
    "gui.device.makeymakey.description": "ಯಾವುದನ್ನಾದರೂ ಕೀಯಾಗಿ ಮಾಡಿ.",
    "gui.sharedMessages.sprite": "Tiffy",
    "gui.device.tifBot.description":
        "TIF-BOT ಎಂಬುದು Wi-Fi, Bluetooth ಮತ್ತು ರೋಬೋಟಿಕ್ಸ್ ಮತ್ತು IoT ಪ್ರಾಜೆಕ್ಟ್‌ಗಳಿಗೆ ಸಮೃದ್ಧ ಪೆರಿಫೆರಲ್‌ಗಳನ್ನು ಹೊಂದಿರುವ ESP32-S3 ಆಧಾರಿತ ಬೋರ್ಡ್ ಆಗಿದೆ.",
    "gui.device.lightWingDrone.description":
        "ಲೈಟ್ ವಿಂಗ್ ಡ್ರೋನ್ ಎಂಬುದು ಸುಧಾರಿತ ಸ್ಥಿರೀಕರಣ ಮತ್ತು Wi-Fi ನಿಯಂತ್ರಣ ಹೊಂದಿರುವ ಉನ್ನತ-ಕಾರ್ಯಕ್ಷಮತೆಯ ESP32-S3 ಆಧಾರಿತ ಫ್ಲೈಟ್ ಕಂಟ್ರೋಲರ್ ಆಗಿದೆ.",
    "gui.device.roboticDog.description":
        "ರೋಬೋಟಿಕ್ ಡಾಗ್ ಎಂಬುದು Arduino Nano ನಿಂದ ಚಾಲಿತವಾದ ಒಂದು ಸ್ಮಾರ್ಟ್ ನಾಲ್ಕು ಕಾಲಿನ ರೋಬೋಟ್ ಆಗಿದ್ದು, ಜೀವಂತ ಚಲನೆಗಳು ಮತ್ತು ಅಡೆತಡೆಗಳಿಂದ ತಪ್ಪಿಸಿಕೊಳ್ಳುವ ಸಾಮರ್ಥ್ಯವನ್ನು ಹೊಂದಿದೆ.",
    "gui.device.roboticArm.description":
        "ರೋಬೋಟಿಕ್ ಆರ್ಮ್ ಎಂಬುದು Arduino Nano ನಿಂದ ಚಾಲಿತವಾದ ಬಹು-ಅಕ್ಷದ ಮ್ಯಾನಿಪ್ಯುಲೇಟರ್ ಆಗಿದ್ದು, ನಿಖರ ಕಾರ್ಯಗಳು ಮತ್ತು ಆಟೋಮೇಷನ್ ಕಲಿಕೆಗಾಗಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾಗಿದೆ.",
    // Music
    "music.categoryName": "ಸಂಗೀತ",
    "music.playDrumForBeats": "ಡ್ರಮ್ [DRUM] [BEATS] ಬೀಟ್‌ಗಳಿಗಾಗಿ ಬಾರಿಸಿ",
    "music.restForBeats": "[BEATS] ಬೀಟ್‌ಗಳಿಗಾಗಿ ವಿಶ್ರಮಿಸಿ",
    "music.playNoteForBeats": "ನೋಟ್ [NOTE] [BEATS] ಬೀಟ್‌ಗಳಿಗಾಗಿ ಬಾರಿಸಿ",
    "music.setInstrument": "ವಾದ್ಯ [INSTRUMENT] ಎಂದು ಹೊಂದಿಸಿ",
    "music.changeTempo": "ಟೆಂಪೋವನ್ನು [TEMPO] ರಿಂದ ಬದಲಾಯಿಸಿ",
    "music.setTempo": "ಟೆಂಪೋವನ್ನು [TEMPO] ಕ್ಕೆ ಹೊಂದಿಸಿ",
    "music.getTempo": "ಟೆಂಪೋ",
    "music.drumBass": "(2) ಬಾಸ್ ಡ್ರಮ್",
    "music.drumBongo": "(13) ಬೊಂಗೊ",
    "music.drumCabasa": "(15) ಕಬಾಸಾ",
    "music.drumClaves": "(9) ಕ್ಲೇವ್ಸ್",
    "music.drumClosedHiHat": "(6) ಮುಚ್ಚಿದ ಹೈ-ಹ್ಯಾಟ್",
    "music.drumConga": "(14) ಕಾಂಗಾ",
    "music.drumCowbell": "(11) ಕೌಬೆಲ್",
    "music.drumCrashCymbal": "(4) ಕ್ರಾಶ್ ಸಿಂಬಲ್",
    "music.drumCuica": "(18) ಕುಯಿಕಾ",
    "music.drumGuiro": "(16) ಗುಯಿರೊ",
    "music.drumHandClap": "(8) ಚಪ್ಪಾಳೆ",
    "music.drumOpenHiHat": "(5) ತೆರೆದ ಹೈ-ಹ್ಯಾಟ್",
    "music.drumSideStick": "(3) ಸೈಡ್ ಸ್ಟಿಕ್",
    "music.drumSnare": "(1) ಸ್ನೇರ್ ಡ್ರಮ್",
    "music.drumTambourine": "(7) ಟ್ಯಾಂಬೊರಿನ್",
    "music.drumTriangle": "(12) ಟ್ರಯಾಂಗಲ್",
    "music.drumVibraslap": "(17) ವೈಬ್ರಾಸ್ಲ್ಯಾಪ್",
    "music.drumWoodBlock": "(10) ವುಡ್ ಬ್ಲಾಕ್",
    "music.instrumentBass": "(6) ಬಾಸ್",
    "music.instrumentBassoon": "(14) ಬಾಸೂನ್",
    "music.instrumentCello": "(8) ಸೆಲ್ಲೋ",
    "music.instrumentChoir": "(15) ಗಾಯಕ ಮಂಡಳಿ (Choir)",
    "music.instrumentClarinet": "(10) ಕ್ಲಾರಿನೆಟ್",
    "music.instrumentElectricGuitar": "(5) ಎಲೆಕ್ಟ್ರಿಕ್ ಗಿಟಾರ್",
    "music.instrumentElectricPiano": "(2) ಎಲೆಕ್ಟ್ರಿಕ್ ಪಿಯಾನೋ",
    "music.instrumentFlute": "(12) ಕೊಳಲು",
    "music.instrumentGuitar": "(4) ಗಿಟಾರ್",
    "music.instrumentMarimba": "(19) ಮರಿಂಬಾ",
    "music.instrumentMusicBox": "(17) ಮ್ಯೂಸಿಕ್ ಬಾಕ್ಸ್",
    "music.instrumentOrgan": "(3) ಆರ್ಗನ್",
    "music.instrumentPiano": "(1) ಪಿಯಾನೋ",
    "music.instrumentPizzicato": "(7) ಪಿಸಿಕ್ಕಾಟೋ",
    "music.instrumentSaxophone": "(11) ಸ್ಯಾಕ್ಸೋಫೋನ್",
    "music.instrumentSteelDrum": "(18) ಸ್ಟೀಲ್ ಡ್ರಮ್",
    "music.instrumentSynthLead": "(20) ಸಿಂತ್ ಲೀಡ್",
    "music.instrumentSynthPad": "(21) ಸಿಂತ್ ಪ್ಯಾಡ್",
    "music.instrumentTrombone": "(9) ಟ್ರೊಂಬೋನ್",
    "music.instrumentVibraphone": "(16) ವೈಬ್ರಾಫೋನ್",
    "music.instrumentWoodenFlute": "(13) ಮರದ ಕೊಳಲು",

    // Pen
    "pen.categoryName": "ಪೆನ್",
    "pen.clear": "ಎಲ್ಲವನ್ನೂ ಅಳಿಸಿ",
    "pen.stamp": "ಸ್ಟಾಂಪ್",
    "pen.penDown": "ಪೆನ್ ಕೆಳಗೆ",
    "pen.penUp": "ಪೆನ್ ಮೇಲೆ",
    "pen.setColor": "ಪೆನ್ ಬಣ್ಣವನ್ನು [COLOR] ಗೆ ಹೊಂದಿಸಿ",
    "pen.changeSize": "ಪೆನ್ ಗಾತ್ರವನ್ನು [SIZE] ರಿಂದ ಬದಲಾಯಿಸಿ",
    "pen.setSize": "ಪೆನ್ ಗಾತ್ರವನ್ನು [SIZE] ಕ್ಕೆ ಹೊಂದಿಸಿ",
    "pen.colorMenu.color": "ಬಣ್ಣ",
    "pen.colorMenu.saturation": "ಸ್ಯಾಚುರೇಶನ್ (Saturation)",
    "pen.colorMenu.brightness": "ಪ್ರಕಾಶ (Brightness)",
    "pen.colorMenu.transparency": "ಪಾರದರ್ಶಕತೆ",

    // Extension Library Names and Descriptions
    "gui.extension.music.name": "ಸಂಗೀತ",
    "gui.extension.music.description": "ವಾದ್ಯಗಳು ಮತ್ತು ಡ್ರಮ್‌ಗಳನ್ನು ನುಡಿಸಿ.",
    "gui.extension.pen.name": "ಪೆನ್",
    "gui.extension.pen.description": "ನಿಮ್ಮ ಸ್ಪ್ರೈಟ್‌ಗಳೊಂದಿಗೆ ಚಿತ್ರಿಸಿ.",
    "gui.extension.videosensing.name": "ವಿಡಿಯೋ ಸೆನ್ಸಿಂಗ್",
    "gui.extension.videosensing.description":
        "ಕ್ಯಾಮೆರಾದೊಂದಿಗೆ ಚಲನೆಯನ್ನು ಗುರುತಿಸಿ.",
    "gui.extension.poseface.name": "ಫೇಸ್ ಸೆನ್ಸಿಂಗ್",
    "gui.extension.poseface.description":
        "ಕ್ಯಾಮೆರಾದೊಂದಿಗೆ ಮುಖದ ಚಲನೆಯನ್ನು ಗುರುತಿಸಿ.",
    "gui.extension.posehand.name": "ಹ್ಯಾಂಡ್ ಸೆನ್ಸಿಂಗ್",
    "gui.extension.posehand.description":
        "ಕ್ಯಾಮೆರಾದೊಂದಿಗೆ ಕೈಯ ಚಲನೆಯನ್ನು ಗುರುತಿಸಿ.",
    "gui.extension.posebody.name": "ಬಾಡಿ ಪೋಸ್ ಸೆನ್ಸಿಂಗ್",
    "gui.extension.posebody.description":
        "ಕ್ಯಾಮೆರಾದೊಂದಿಗೆ ದೇಹದ ಚಲನೆಯನ್ನು ಗುರುತಿಸಿ.",
    "gui.extension.teachablemachine.name": "ಟೀಚಬಲ್ ಮೆಷಿನ್",
    "gui.extension.teachablemachine.description":
        "ನಿಮ್ಮ ಕ್ಯಾಮೆರಾದೊಂದಿಗೆ ಕಸ್ಟಮ್ ಮೆಷಿನ್ ಲರ್ನಿಂಗ್ ಮಾಡೆಲ್‌ಗಳನ್ನು ಬಳಸಿ.",
    "gui.extension.text2speech.name": "ಟೆಕ್ಸ್ಟ್ ಟು ಸ್ಪೀಚ್",
    "gui.extension.text2speech.description": "ನಿಮ್ಮ ಯೋಜನೆಗಳನ್ನು ಮಾತನಾಡಿಸಿ.",
    "gui.extension.translate.name": "ಅನುವಾದ",
    "gui.extension.translate.description":
        "ಪಠ್ಯವನ್ನು ಅನೇಕ ಭಾಷೆಗಳಿಗೆ ಅನುವಾದಿಸಿ.",
    "gui.extension.makeymakey.name": "ಮೇಕಿ ಮೇಕಿ",
    "gui.extension.makeymakey.description":
        "ಯಾವುದನ್ನಾದರೂ ಕೀಯನ್ನಾಗಿ (Key) ಮಾಡಿ.",

    // Arduino Translations
    "arduinoUno.category.pins": "ಪಿನ್",
    "arduinoUno.category.serial": "ಸೀರಿಯಲ್",
    "arduinoUno.category.data": "ಡೇಟಾ",

    "arduinoNano.category.pins": "ಪಿನ್",
    "arduinoNano.category.serial": "ಸೀರಿಯಲ್",
    "arduinoNano.category.data": "ಡೇಟಾ",

    "arduinoLeonardo.category.pins": "ಪಿನ್",
    "arduinoLeonardo.category.serial": "ಸೀರಿಯಲ್",
    "arduinoLeonardo.category.data": "ಡೇಟಾ",

    "arduinoMega2560.category.pins": "ಪಿನ್",
    "arduinoMega2560.category.serial": "ಸೀರಿಯಲ್",
    "arduinoMega2560.category.data": "ಡೇಟಾ",

    "arduinoEsp32.category.pins": "ಪಿನ್",
    "arduinoEsp32.category.serial": "ಸೀರಿಯಲ್",
    "arduinoEsp32.category.data": "ಡೇಟಾ",

    "arduinoEsp8266.category.pins": "ಪಿನ್",
    "arduinoEsp8266.category.serial": "ಸೀರಿಯಲ್",
    "arduinoEsp8266.category.data": "ಡೇಟಾ",

    "arduinoK210.category.pins": "ಪಿನ್",
    "arduinoK210.category.serial": "ಸೀರಿಯಲ್",
    "arduinoK210.category.data": "ಡೇಟಾ",

    "arduinoRaspberryPiPico.category.pins": "ಪಿನ್",
    "arduinoRaspberryPiPico.category.serial": "ಸೀರಿಯಲ್",
    "arduinoRaspberryPiPico.category.data": "ಡೇಟಾ",

    // Arduino Uno Blocks
    "arduinoUno.modeMenu.input": "ಇನ್‌ಪುಟ್",
    "arduinoUno.modeMenu.output": "ಔಟ್‌ಪುಟ್",
    "arduinoUno.modeMenu.inputPullup": "ಇನ್‌ಪುಟ್-ಪುಲ್‌ಅಪ್",
    "arduinoUno.levelMenu.high": "ಹೈ (High)",
    "arduinoUno.levelMenu.low": "ಲೋ (Low)",
    "arduinoUno.pins.setPinMode": "ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಸೆಟ್ ಮಾಡಿ",
    "arduinoUno.pins.setDigitalOutput":
        "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಔಟ್ [LEVEL] ಸೆಟ್ ಮಾಡಿ",
    "arduinoUno.pins.setPwmOutput": "PWM ಪಿನ್ [PIN] ಆವೃತ್ತಿ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoUno.pins.readDigitalPin": "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoUno.pins.readAnalogPin": "ಅನಲಾಗ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoUno.pins.setServoOutput": "ಸರ್ವೋ ಪಿನ್ [PIN] ಔಟ್ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoUno.pins.attachInterrupt":
        "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಲಗತ್ತಿಸಿ",
    "arduinoUno.pins.detachInterrupt": "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಬೇರ್ಪಡಿಸಿ",
    "arduinoUno.serial.serialBegin": "ಸೀರಿಯಲ್ ಪ್ರಾರಂಭ ಬೌಡರೇಟ್ [VALUE]",
    "arduinoUno.serial.serialPrint": "ಸೀರಿಯಲ್ ಪ್ರಿಂಟ್ [VALUE] [EOL]",
    "arduinoUno.serial.serialAvailable": "ಸೀರಿಯಲ್ ಲಭ್ಯವಿರುವ ಡೇಟಾ ಉದ್ದ",
    "arduinoUno.serial.serialReadAByte": "ಸೀರಿಯಲ್ ಒಂದು ಬೈಟ್ ಓದಿ",
    "arduinoUno.data.dataMap":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಿಂದ ([ARG2], [ARG3]) ಗೆ ಮ್ಯಾಪ್ ಮಾಡಿ",

    // Arduino Nano Blocks
    "arduinoNano.modeMenu.input": "ಇನ್‌ಪುಟ್",
    "arduinoNano.modeMenu.output": "ಔಟ್‌ಪುಟ್",
    "arduinoNano.modeMenu.inputPullup": "ಇನ್‌పుಟ್-ಪುಲ್‌ಅಪ್",
    "arduinoNano.levelMenu.high": "ಹೈ (High)",
    "arduinoNano.levelMenu.low": "ಲೋ (Low)",
    "arduinoNano.pins.setPinMode": "ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಸೆಟ್ ಮಾಡಿ",
    "arduinoNano.pins.setDigitalOutput":
        "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಔಟ್ [LEVEL] ಸೆಟ್ ಮಾಡಿ",
    "arduinoNano.pins.setPwmOutput": "PWM ಪಿನ್ [PIN] ಆವೃತ್ತಿ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoNano.pins.readDigitalPin": "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoNano.pins.readAnalogPin": "ಅನಲಾಗ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoNano.pins.setServoOutput": "ಸರ್ವೋ ಪಿನ್ [PIN] ಔಟ್ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoNano.pins.attachInterrupt":
        "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಲಗತ್ತಿಸಿ",
    "arduinoNano.pins.detachInterrupt": "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಬೇರ್ಪಡಿಸಿ",
    "arduinoNano.serial.serialBegin": "ಸೀರಿಯಲ್ ಪ್ರಾರಂಭ ಬೌಡರೇಟ್ [VALUE]",
    "arduinoNano.serial.serialPrint": "ಸೀರಿಯಲ್ ಪ್ರಿಂಟ್ [VALUE] [EOL]",
    "arduinoNano.serial.serialAvailable": "ಸೀರಿಯಲ್ ಲಭ್ಯವಿರುವ ಡೇಟಾ ಉದ್ದ",
    "arduinoNano.serial.serialReadAByte": "ಸೀರಿಯಲ್ ಒಂದು ಬೈಟ್ ಓದಿ",
    "arduinoNano.data.dataMap":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಿಂದ ([ARG2], [ARG3]) ಗೆ ಮ್ಯಾಪ್ ಮಾಡಿ",

    // Arduino Leonardo Blocks
    "arduinoLeonardo.modeMenu.input": "ಇನ್‌ಪುಟ್",
    "arduinoLeonardo.modeMenu.output": "ಔಟ್‌ಪುಟ್",
    "arduinoLeonardo.modeMenu.inputPullup": "ಇನ್‌ಪುಟ್-ಪುಲ್‌ಅಪ್",
    "arduinoLeonardo.levelMenu.high": "ಹೈ (High)",
    "arduinoLeonardo.levelMenu.low": "ಲೋ (Low)",
    "arduinoLeonardo.pins.setPinMode": "ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಸೆಟ್ ಮಾಡಿ",
    "arduinoLeonardo.pins.setDigitalOutput":
        "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಔಟ್ [LEVEL] ಸೆಟ್ ಮಾಡಿ",
    "arduinoLeonardo.pins.setPwmOutput":
        "PWM ಪಿನ್ [PIN] ಆವೃತ್ತಿ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoLeonardo.pins.readDigitalPin": "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoLeonardo.pins.readAnalogPin": "ಅನಲಾಗ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoLeonardo.pins.setServoOutput":
        "ಸರ್ವೋ ಪಿನ್ [PIN] ಔಟ್ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoLeonardo.pins.attachInterrupt":
        "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಲಗತ್ತಿಸಿ",
    "arduinoLeonardo.pins.detachInterrupt": "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಬೇರ್ಪಡಿಸಿ",
    "arduinoLeonardo.serial.serialBegin": "ಸೀರಿಯಲ್ ಪ್ರಾರಂಭ ಬೌಡರೇಟ್ [VALUE]",
    "arduinoLeonardo.serial.serialPrint": "ಸೀರಿಯಲ್ ಪ್ರಿಂಟ್ [VALUE] [EOL]",
    "arduinoLeonardo.serial.serialAvailable": "ಸೀರಿಯಲ್ ಲಭ್ಯವಿರುವ ಡೇಟಾ ಉದ್ದ",
    "arduinoLeonardo.serial.serialReadAByte": "ಸೀರಿಯಲ್ ಒಂದು ಬೈಟ್ ಓದಿ",
    "arduinoLeonardo.data.dataMap":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಿಂದ ([ARG2], [ARG3]) ಗೆ ಮ್ಯಾಪ್ ಮಾಡಿ",

    // Arduino Mega2560 Blocks
    "arduinoMega2560.modeMenu.input": "ಇನ್‌ಪುಟ್",
    "arduinoMega2560.modeMenu.output": "ಔಟ್‌ಪುಟ್",
    "arduinoMega2560.modeMenu.inputPullup": "ಇನ್‌ಪುಟ್-ಪುಲ್‌ಅಪ್",
    "arduinoMega2560.levelMenu.high": "ಹೈ (High)",
    "arduinoMega2560.levelMenu.low": "ಲೋ (Low)",
    "arduinoMega2560.pins.setPinMode": "ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಸೆಟ್ ಮಾಡಿ",
    "arduinoMega2560.pins.setDigitalOutput":
        "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಔಟ್ [LEVEL] ಸೆಟ್ ಮಾಡಿ",
    "arduinoMega2560.pins.setPwmOutput":
        "PWM ಪಿನ್ [PIN] ಆವೃತ್ತಿ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoMega2560.pins.readDigitalPin": "ಡಿಜಿಟಲ್ ಪಿన్ [PIN] ಓದಿ",
    "arduinoMega2560.pins.readAnalogPin": "ಅನಲಾಗ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoMega2560.pins.setServoOutput":
        "ಸರ್ವೋ ಪಿನ್ [PIN] ಔಟ್ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoMega2560.pins.attachInterrupt":
        "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಲಗತ್ತಿಸಿ",
    "arduinoMega2560.pins.detachInterrupt": "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಬೇರ್ಪಡಿಸಿ",
    "arduinoMega2560.serial.serialBegin": "ಸೀರಿಯಲ್ ಪ್ರಾರಂಭ ಬೌಡರೇಟ್ [VALUE]",
    "arduinoMega2560.serial.serialPrint": "ಸೀರಿಯಲ್ ಪ್ರಿಂಟ್ [VALUE] [EOL]",
    "arduinoMega2560.serial.serialAvailable": "ಸೀರಿಯಲ್ ಲಭ್ಯವಿರುವ ಡೇಟಾ ಉದ್ದ",
    "arduinoMega2560.serial.serialReadAByte": "ಸೀರಿಯಲ್ ಒಂದು ಬೈಟ್ ಓದಿ",
    "arduinoMega2560.data.dataMap":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಿಂದ ([ARG2], [ARG3]) ಗೆ ಮ್ಯಾಪ್ ಮಾಡಿ",

    // Arduino ESP32 Blocks
    "arduinoEsp32.modeMenu.input": "ಇನ್‌ಪುಟ್",
    "arduinoEsp32.modeMenu.output": "ಔಟ್‌ಪುಟ್",
    "arduinoEsp32.modeMenu.inputPullup": "ಇನ್‌ಪುಟ್-ಪುಲ್‌ಅಪ್",
    "arduinoEsp32.levelMenu.high": "ಹೈ (High)",
    "arduinoEsp32.levelMenu.low": "ಲೋ (Low)",
    "arduinoEsp32.pins.setPinMode": "ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಸೆಟ್ ಮಾಡಿ",
    "arduinoEsp32.pins.setDigitalOutput":
        "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಔಟ್ [LEVEL] ಸೆಟ್ ಮಾಡಿ",
    "arduinoEsp32.pins.setPwmOutput": "PWM ಪಿನ್ [PIN] ಆವೃತ್ತಿ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoEsp32.pins.readDigitalPin": "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoEsp32.pins.readAnalogPin": "ಅನಲಾಗ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoEsp32.pins.setServoOutput": "ಸರ್ವೋ ಪಿನ್ [PIN] ಔಟ್ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoEsp32.pins.attachInterrupt":
        "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಲಗತ್ತಿಸಿ",
    "arduinoEsp32.pins.detachInterrupt": "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಬೇರ್ಪಡಿಸಿ",
    "arduinoEsp32.serial.serialBegin": "ಸೀರಿಯಲ್ ಪ್ರಾರಂಭ ಬೌಡರೇಟ್ [VALUE]",
    "arduinoEsp32.serial.serialPrint": "ಸೀರಿಯಲ್ ಪ್ರಿಂಟ್ [VALUE] [EOL]",
    "arduinoEsp32.serial.serialAvailable": "ಸೀರಿಯಲ್ ಲಭ್ಯವಿರುವ ಡೇಟಾ ಉದ್ದ",
    "arduinoEsp32.serial.serialReadAByte": "ಸೀರಿಯಲ್ ಒಂದು ಬೈಟ್ ಓದಿ",
    "arduinoEsp32.data.dataMap":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಿಂದ ([ARG2], [ARG3]) ಗೆ ಮ್ಯಾಪ್ ಮಾಡಿ",

    // Arduino ESP8266 Blocks
    "arduinoEsp8266.modeMenu.input": "ಇನ್‌ಪುಟ್",
    "arduinoEsp8266.modeMenu.output": "ಔಟ್‌ಪುಟ್",
    "arduinoEsp8266.modeMenu.inputPullup": "ಇನ್‌ಪುಟ್-ಪುಲ್‌ಅಪ್",
    "arduinoEsp8266.levelMenu.high": "ಹೈ (High)",
    "arduinoEsp8266.levelMenu.low": "ಲೋ (Low)",
    "arduinoEsp8266.pins.setPinMode": "ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಸೆಟ್ ಮಾಡಿ",
    "arduinoEsp8266.pins.setDigitalOutput":
        "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಔಟ್ [LEVEL] ಸೆಟ್ ಮಾಡಿ",
    "arduinoEsp8266.pins.setPwmOutput":
        "PWM ಪಿన్ [PIN] ಆವೃತ್ತಿ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoEsp8266.pins.readDigitalPin": "ಡಿಜಿಟಲ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoEsp8266.pins.readAnalogPin": "ಅನಲಾಗ್ ಪಿನ್ [PIN] ಓದಿ",
    "arduinoEsp8266.pins.setServoOutput":
        "ಸರ್ವೋ ಪಿನ್ [PIN] ಔಟ್ [OUT] ಸೆಟ್ ಮಾಡಿ",
    "arduinoEsp8266.pins.attachInterrupt":
        "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಮೋಡ್ [MODE] ಲಗತ್ತಿಸಿ",
    "arduinoEsp8266.pins.detachInterrupt": "ಇಂಟರಪ್ಟ್ ಪಿನ್ [PIN] ಬೇರ್ಪಡಿಸಿ",
    "arduinoEsp8266.serial.serialBegin": "ಸೀರಿಯಲ್ ಪ್ರಾರಂಭ ಬೌಡರೇಟ್ [VALUE]",
    "arduinoEsp8266.serial.serialPrint": "ಸೀರಿಯಲ್ ಪ್ರಿಂಟ್ [VALUE] [EOL]",
    "arduinoEsp8266.serial.serialAvailable": "ಸೀರಿಯಲ್ ಲಭ್ಯವಿರುವ ಡೇಟಾ ಉದ್ದ",
    "arduinoEsp8266.serial.serialReadAByte": "ಸೀರಿಯಲ್ ಒಂದು ಬೈಟ್ ಓದಿ",
    "arduinoEsp8266.data.dataMap":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಿಂದ ([ARG2], [ARG3]) ಗೆ ಮ್ಯಾಪ್ ಮಾಡಿ",
    // Additional Data Blocks
    "arduinoUno.data.dataConstrain":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಡುವೆ ಮಿತಿಗೊಳಿಸಿ",
    "arduinoUno.data.dataConvert": "[DATA] ಅನ್ನು [TYPE] ಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoUno.data.dataConvertASCIICharacter":
        "[DATA] ಅನ್ನು ASCII ಅಕ್ಷರಕ್ಕೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoUno.data.dataConvertASCIINumber":
        "[DATA] ಅನ್ನು ASCII ಸಂಖ್ಯೆಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoUno.dataTypeMenu.integer": "ಪೂರ್ಣಾಂಕ",
    "arduinoUno.dataTypeMenu.decimal": "ದಶಮಾಂಶ",
    "arduinoUno.dataTypeMenu.string": "ಸ್ಟ್ರಿಂಗ್",

    "arduinoNano.data.dataConstrain":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಡುವೆ ಮಿತಿಗೊಳಿಸಿ",
    "arduinoNano.data.dataConvert": "[DATA] ಅನ್ನು [TYPE] ಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoNano.data.dataConvertASCIICharacter":
        "[DATA] ಅನ್ನು ASCII ಅಕ್ಷರಕ್ಕೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoNano.data.dataConvertASCIINumber":
        "[DATA] ಅನ್ನು ASCII ಸಂಖ್ಯೆಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoNano.dataTypeMenu.integer": "ಪೂರ್ಣಾಂಕ",
    "arduinoNano.dataTypeMenu.decimal": "ದಶಮಾಂಶ",
    "arduinoNano.dataTypeMenu.string": "ಸ್ಟ್ರಿಂಗ್",

    "arduinoLeonardo.data.dataConstrain":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಡುವೆ ಮಿತಿಗೊಳಿಸಿ",
    "arduinoLeonardo.data.dataConvert": "[DATA] ಅನ್ನು [TYPE] ಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoLeonardo.data.dataConvertASCIICharacter":
        "[DATA] ಅನ್ನು ASCII ಅಕ್ಷರಕ್ಕೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoLeonardo.data.dataConvertASCIINumber":
        "[DATA] ಅನ್ನು ASCII ಸಂಖ್ಯೆಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoLeonardo.dataTypeMenu.integer": "ಪೂರ್ಣಾಂಕ",
    "arduinoLeonardo.dataTypeMenu.decimal": "ದಶಮಾಂಶ",
    "arduinoLeonardo.dataTypeMenu.string": "ಸ್ಟ್ರಿಂಗ್",

    "arduinoMega2560.data.dataConstrain":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಡುವೆ ಮಿತಿಗೊಳಿಸಿ",
    "arduinoMega2560.data.dataConvert": "[DATA] ಅನ್ನು [TYPE] ಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoMega2560.data.dataConvertASCIICharacter":
        "[DATA] ಅನ್ನು ASCII ಅಕ್ಷರಕ್ಕೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoMega2560.data.dataConvertASCIINumber":
        "[DATA] ಅನ್ನು ASCII ಸಂಖ್ಯೆಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoMega2560.dataTypeMenu.integer": "ಪೂರ್ಣಾಂಕ",
    "arduinoMega2560.dataTypeMenu.decimal": "ದಶಮಾಂಶ",
    "arduinoMega2560.dataTypeMenu.string": "ಸ್ಟ್ರಿಂಗ್",

    "arduinoEsp32.data.dataConstrain":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಡುವೆ ಮಿತಿಗೊಳಿಸಿ",
    "arduinoEsp32.data.dataConvert": "[DATA] ಅನ್ನು [TYPE] ಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoEsp32.data.dataConvertASCIICharacter":
        "[DATA] ಅನ್ನು ASCII ಅಕ್ಷರಕ್ಕೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoEsp32.data.dataConvertASCIINumber":
        "[DATA] ಅನ್ನು ASCII ಸಂಖ್ಯೆಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoEsp32.dataTypeMenu.integer": "ಪೂರ್ಣಾಂಕ",
    "arduinoEsp32.dataTypeMenu.decimal": "ದಶಮಾಂಶ",
    "arduinoEsp32.dataTypeMenu.string": "ಸ್ಟ್ರಿಂಗ್",

    "arduinoEsp8266.data.dataConstrain":
        "[DATA] ಅನ್ನು ([ARG0], [ARG1]) ನಡುವೆ ಮಿತಿಗೊಳಿಸಿ",
    "arduinoEsp8266.data.dataConvert": "[DATA] ಅನ್ನು [TYPE] ಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoEsp8266.data.dataConvertASCIICharacter":
        "[DATA] ಅನ್ನು ASCII ಅಕ್ಷರಕ್ಕೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoEsp8266.data.dataConvertASCIINumber":
        "[DATA] ಅನ್ನು ASCII ಸಂಖ್ಯೆಗೆ ಪರಿವರ್ತಿಸಿ",
    "arduinoEsp8266.dataTypeMenu.integer": "ಪೂರ್ಣಾಂಕ",
    "arduinoEsp8266.dataTypeMenu.decimal": "ದಶಮಾಂಶ",
    "arduinoEsp8266.dataTypeMenu.string": "ಸ್ಟ್ರಿಂಗ್",
    "gui.boardManager.title": "ಬೋರ್ಡ್ ಮ್ಯಾನೇಜರ್",

    // Library manager & Board manager
    "gui.librariesBoardsTab": "ಲೈಬ್ರರಿಗಳು",
    "gui.boardManagerTab": "ಬೋರ್ಡ್ ಮ್ಯಾನೇಜರ್",

    "gui.boardManager.description":
        "ಅಧಿಕೃತ Arduino ಬೋರ್ಡ್‌ಗಳನ್ನು ಹುಡುಕಿ ಮತ್ತು ಸ್ಥಾಪಿಸಿ.",
    "gui.boardManager.searchPlaceholder": "Arduino ಬೋರ್ಡ್ ಹುಡುಕಿ (ಉದಾ: esp32)",
    "gui.boardManager.search": "ಹುಡುಕಿ",
    "gui.boardManager.searching": "ಹುಡುಕುತ್ತಿದೆ...",
    "gui.boardManager.advancedOptionsShow":
        "▶ ಸುಧಾರಿತ ಆಯ್ಕೆಗಳು (ಕಸ್ಟಮ್ ಇನ್‌ಸ್ಟಾಲ್ ಪಥ)",
    "gui.boardManager.advancedOptionsHide": "▼ ಸುಧಾರಿತ ಆಯ್ಕೆಗಳನ್ನು ಮರೆಮಾಡಿ",
    "gui.boardManager.recommended": "ಶಿಫಾರಸು ಮಾಡಲಾದ",
    "gui.boardManager.installed": "ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಲಾಗಿದೆ ({count})",
    "gui.boardManager.searchResults": "ಹುಡುಕಾಟ ಫಲಿತಾಂಶಗಳು {count}",
    "gui.boardManager.refresh": "↻ ರಿಫ್ರೆಶ್",
    "gui.boardManager.refreshing": "↻ ರಿಫ್ರೆಶ್ ಆಗುತ್ತಿದೆ...",

    "gui.libraryManager.title": "ಲೈಬ್ರರಿ ಮ್ಯಾನೇಜರ್",
    "gui.libraryManager.description":
        "ಅಧಿಕೃತ Arduino ಲೈಬ್ರರಿಗಳನ್ನು ಹುಡುಕಿ ಮತ್ತು ಸ್ಥಾಪಿಸಿ.",
    "gui.libraryManager.searchPlaceholder":
        "Arduino ಲೈಬ್ರರಿ ಹುಡುಕಿ (ಉದಾ: Servo)",
    "gui.libraryManager.search": "ಹುಡುಕಿ",
    "gui.libraryManager.searching": "ಹುಡುಕುತ್ತಿದೆ...",
    "gui.libraryManager.advancedOptionsShow":
        "▶ ಸುಧಾರಿತ ಆಯ್ಕೆಗಳು (ಕಸ್ಟಮ್ ಇನ್‌ಸ್ಟಾಲ್ ಪಥ)",
    "gui.libraryManager.advancedOptionsHide": "▼ ಸುಧಾರಿತ ಆಯ್ಕೆಗಳನ್ನು ಮರೆಮಾಡಿ",
    "gui.libraryManager.recommended": "ಶಿಫಾರಸು ಮಾಡಲಾದ",
    "gui.libraryManager.installed": "ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಲಾಗಿದೆ ({count})",
    "gui.libraryManager.searchResults": "ಹುಡುಕಾಟ ಫಲಿತಾಂಶಗಳು {count}",
    "gui.libraryManager.refresh": "↻ ರಿಫ್ರೆಶ್",
    "gui.libraryManager.refreshing": "↻ ರಿಫ್ರೆಶ್ ಆಗುತ್ತಿದೆ...",
    "gui.gui.librariesBoardsTab": "ಲೈಬ್ರರಿಗಳು",
    "gui.gui.boardsManagerTab": "ಬೋರ್ಡ್ ಮ್ಯಾನೇಜರ್",
};

export default kn;
